import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHeading, Reveal } from "@/components/Reveal";
import PropertyCard from "@/components/PropertyCard";

export default function FeaturedProperties() {
  const [properties, setProperties] = useState(null);

  useEffect(() => {
    api
      .get("/properties?featured=true")
      .then((r) => setProperties(r.data.slice(0, 6)))
      .catch(() => setProperties([]));
  }, []);

  return (
    <section id="featured" data-testid="featured-properties-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <SectionHeading
            chapter="01"
            eyebrow="Curated Listings"
            title="Featured Investment Opportunities"
            description="A selection of residential, commercial and investment plots around Nagpur's key connectivity corridors."
          />
          <Reveal delay={0.2}>
            <Link
              to="/properties"
              data-testid="view-all-properties-link"
              className="group flex items-center gap-2 whitespace-nowrap text-sm font-bold uppercase tracking-wider text-navy transition-colors hover:text-gold-dark"
            >
              View All Properties
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {properties === null
            ? [0, 1, 2].map((i) => (
                <div key={i} className="h-96 animate-pulse rounded-xl bg-gray-100" aria-hidden="true" />
              ))
            : properties.map((p, i) => <PropertyCard key={p.id} property={p} index={i} />)}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 text-xs text-muted-foreground">
            Listings marked &ldquo;Sample Listing&rdquo; are placeholder entries and will be replaced with live property details.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
